import React from "react";

import PropTypes from "prop-types";
import AnalyticsTracking from "Utils/AnalyticsTracking";
/*
This is a wrapper for components or groups of components that need tracking for
analytics, like popover triggers and overlays.  It records how long a user spent
looking at a Popover. Pass in trackType (e.g. 'plan-card-plan-term' or 'filter')
and trackId (e.g. Network Strength, HSA Eligible, etc.) to specify what tooltip
is being used in tracking.
*/

export default class OverlayTrackingWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      startTrackEvent: null,
    };
  }

  render() {
    return (
      <span onMouseEnter={this.handleShow.bind(this)} onMouseLeave={this.handleHide.bind(this)} className={this.props.className}>
        {this.props.children}
      </span>
    );
  }

  handleShow() {
    if (this.props.onEnter) {
      this.props.onEnter();
    }

    // Record how long the tooltip is open for
    this.setState({
      startTrackEvent: Date.now(),
    });
  }

  handleHide() {
    if (this.props.onExit) {
      this.props.onExit();
    }

    // Create tracking event
    const endTrackEvent = Date.now();

    if (endTrackEvent - this.state.startTrackEvent > 1000) {
      AnalyticsTracking.trackEvent("tooltip_used", {
        type: this.props.trackType,
        label: this.props.trackId,
        time_spent: endTrackEvent - this.state.startTrackEvent,
      });
    }

    this.setState({
      startTrackEvent: null,
    });
  }
}
OverlayTrackingWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

OverlayTrackingWrapper.defaultProps = function () {
  return {
    placement: "right",
  };
};
